import React from 'react'
import SubmenuItem from './SubmenuItem'
import { getCategoryAccessSubCategory } from '../../../../helpers/user/UserHelper'
import { useSelector } from 'react-redux'

const Submenu = ({ list }) => {

    const user = useSelector(state => state.user.user)

    const isAccess = (path) => {
        let access = false
        
        // console.log('category', category)

        access = getCategoryAccessSubCategory ({ 
            // path: window.location.pathname, 
            path: path, 
            permissions: user && user.permissions ? user.permissions : null,
            // categoryName: category
        })

        return access
    }
    

  return (
    <ul className='submenuTop'>
        {
            list && list.length > 0 ?
                list.map(item => {
                    if (isAccess(item.url)) {
                        return (
                            <SubmenuItem 
                                key={item.url}
                                item={item}
                            />
                        )
                    }
                })
            : ''
        }
        {/* <li>
            <Link
                to='#test'
                className='active'
            >
                <FormatListBulletedIcon />
                <span>Список задач</span>
            </Link>
        </li>
        <li>
            <Link to='#test'>
                <FormatListBulletedIcon />
                <span>Список задач</span>
            </Link>
        </li> */}
    </ul>
  )
}

export default Submenu